import React from "react"
import Logo from "./logo.svg"

export const LogoSolid = () => {
  return <img src={Logo} alt="Hadley Logo" />
}
